import { defineNuxtPlugin } from "#app";
import { addRouteMiddleware } from "#imports";


const hasUtm = (query: any): boolean => {
	return Object.keys(query).some(key => key.indexOf("utm") > -1);
};

const getUtms = (query: any) => {
	return Object.keys(query)
		.filter(key => key.indexOf("utm") > -1)
		.map(key => ({ [key]: query[key] }))
		.reduce((a,b) => ({ ...a, ...b }), {});
};

export default defineNuxtPlugin(nuxtApp => {
	addRouteMiddleware('utm-manager-mid', (to, from) => {
		const utms = getUtms(from.query);
		if (!hasUtm(to.query) && hasUtm(utms)) {
			to.query = {
				...to.query,
				...utms
			};
			return to;
		}
	}, { global: true });
});
